import { decamelizeKeys } from 'humps'

// Our default settings do not fully decamelize strings that end with numbers
// i.e. `addressLine1` would be `address_line1`, so this custom `split` param
// solves that
export const decamelizeKeysWithNumbers = (body: Object): Object => {
  return decamelizeKeys(body, { split: /(?=[A-Z0-9])/ })
}
